module.exports = __webpack_public_path__ + "static/media/waterTreatment.e863c7eb.jpg";